module.exports = __webpack_public_path__ + "static/media/Screenshot_10.7235f303.png";